import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import OutboundScanner from '@/components/OutboundScanner';
import InboundScanner from '@/components/InboundScanner';
import { usePageHeader } from '@/contexts/HeaderContext';

interface PackageData {
  id: string;
  packageNumber: string;
  slotCode: string;
  barcodes: string[];
  name?: string;
}

const ScanScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'inbound';
  const [error, setError] = useState<string | null>(null);

  const handleOutboundSuccess = (imageUrl: string, packageData: any | null) => {
    if (!packageData) {
      navigate(`/outbound?imageUrl=${encodeURIComponent(imageUrl)}`);
    } else {
      navigate(`/outbound`, { state: { packageData } });
    }
  };

  const handleHeaderBack = useCallback(() => navigate('/'), [navigate]);

  // Must be memoized — an inline JSX title re-renders forever. Same as the
  // other pages that use usePageHeader.
  const headerTitle = useMemo(() => <>📷 {t('capture_parcel')}</>, [t]);

  usePageHeader({ title: headerTitle, onBack: handleHeaderBack });

  return (
    <div className="min-h-[calc(100vh-73px)] bg-background flex flex-col">
      {/* Scanner area */}
      <div className="flex-1 relative bg-background px-4 py-3">
        {mode === 'inbound' ? (
          <InboundScanner error={error} onError={setError} />
        ) : (
          <OutboundScanner onScanSuccess={handleOutboundSuccess} onError={setError} />
        )}
      </div>
    </div>
  );
};

export default ScanScreen;
